import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { importProvidersFrom, LOCALE_ID } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Configuration } from './api';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { provideAzureADB2C } from './providers/authentication.provider';
import { API_CONFIGURATION } from 'elior-group.joyfood.packages.order-validator';
import { provideNzI18n, it_IT, en_US } from 'ng-zorro-antd/i18n';
import { RequestParserInterceptor } from './interceptors/request-parser.interceptor';
import { LanguageService } from './shared/services/language/language.service';
registerLocaleData(localeIt, 'it');
registerLocaleData(localeEn, 'en');

const configurationFactory = () =>
  new Configuration({
    basePath: environment.apiConfig.webApiUri,
  });
bootstrapApplication(AppComponent, {

  providers: [
    {
      provide: Configuration,
      useFactory: configurationFactory,
      multi: false,
    },
    {
      provide: API_CONFIGURATION,
      useFactory: configurationFactory,
      multi: false,
    },
    provideNzI18n(it_IT),
    provideNzI18n(en_US),
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: RequestParserInterceptor, multi: true },
    importProvidersFrom(
      BrowserAnimationsModule,
      TranslateModule.forRoot({
        loader: { provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient] },
      }),
    ),
    provideRouter(routes),
    provideAzureADB2C(),
    {
      provide: LOCALE_ID,
      useFactory: localeIdFactory,
      deps: [LanguageService]
    }
  ]
})
  .catch(err => console.error(err));


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function localeIdFactory(languageService: LanguageService): string {
  const lang = languageService.getCurrentLanguage();
  return lang+'-'+lang.toLocaleUpperCase();
}
